/*
 * Authors: Triadi, mariushirjanu
 * Created: 31/01/2020
 * Upgraded: 13/09/2022
 */
import { Injectable } from '@angular/core';
import { FormattingService } from '../../../shared/services/formatting.service';
import { ICustomerPermissionExtended, IOrderQuotePermissionResponse } from '../../../shared/user/user-data.service';
import { TranslationService } from '../../../shared/translation/translation.service';

@Injectable()
export class PermissionsService {
  constructor(
    private translationService:TranslationService,
    private formattingService:FormattingService
  ) {
    /**/
  }

  public getCustomerPermissions(permissions:IOrderQuotePermissionResponse):ICustomerPermissionExtended {
    if (!permissions || !permissions.customerPermission) {
      return;
    }

    const customerPermissions:ICustomerPermissionExtended = permissions.customerPermission;

    // add the texts if the orders and quotes can be placed, view and view by others
    if (customerPermissions.canPlaceOrder || customerPermissions.canPlaceQuote) {
      customerPermissions.canPlaceText = this.translationService.instant('APP.USER_PROFILE.PERMISSIONS.CAN_PLACE', {
        types: this.generateOrderQuotesText(customerPermissions.canPlaceOrder, customerPermissions.canPlaceQuote)
      });
    }
    if (customerPermissions.viewOthersOrder || customerPermissions.viewOthersQuote) {
      customerPermissions.canViewOthersText = this.translationService.instant('APP.USER_PROFILE.PERMISSIONS.CAN_VIEW_OTHERS', {
        types: this.generateOrderQuotesText(customerPermissions.viewOthersOrder, customerPermissions.viewOthersQuote)
      });
    }
    if (customerPermissions.viewOnlyOwnOrder || customerPermissions.viewOnlyOwnQuote) {
      customerPermissions.canViewOwnText = this.translationService.instant('APP.USER_PROFILE.PERMISSIONS.CAN_VIEW_OWN', {
        types: this.generateOrderQuotesText(customerPermissions.viewOnlyOwnOrder, customerPermissions.viewOnlyOwnQuote)
      });
    }

    return customerPermissions;
  }

  // this generates the folowing texts based on the input values: order and quote / order / quote
  private generateOrderQuotesText(orderPermssion:boolean, quotePermission:boolean):string {
    return this.formattingService.join(
      orderPermssion? this.translationService.instant('GA.GENERAL.ORDERS') : '',
      quotePermission? this.translationService.instant('GA.GENERAL.QUOTES') : '',
      ` ${this.translationService.instant('GA.GENERAL.AND')} `
    );
  }
}